import React, { useEffect, useState } from 'react';
import { getReportedProducts } from '../../../../services/product';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { isAuthenticated } from '../../../../services/auth';
import { message, Pagination, Popconfirm } from 'antd';
import { approveReport, rejectReport } from '../../../../services/admin';
import UnifiedDashboard from '../../../../components/layout/UnifiedDashboard';
import './ReportedProducts.css';

const ReportedProducts = () => {
  const countPerPage = 5;
  const [reports, setReports] = useState([]);
  const [current, setCurrent] = useState();
  const [report, setReport] = useState(false);
  const [pagination, setPagination] = useState([]);

  const { token } = isAuthenticated();

  useEffect(() => {
    loadReports(1);
  }, [report]);

  const loadReports = async (page) => {
    const res = await getReportedProducts();
    setReports(res.data);
    setCurrent(page);
    const to = page * countPerPage;
    const from = to - countPerPage;
    setPagination(res.data.slice(from, to));
  };

  const handleApprove = async (productId) => {
    try {
      await approveReport(productId, token);
      message.success('Report Approved');
      report ? setReport(false) : setReport(true);
    } catch (err) {
      console.log(err);
      if (err.response.status === 400) message.error(err.response.data, 4);
    }
  };
  const handleReject = async (productId) => {
    try {
      await rejectReport(productId, token);
      message.success('Report Approved');
      !report ? setReport(true) : setReport(false);
    } catch (err) {
      console.log(err);
      if (err.response.status === 400) message.error(err.response.data, 4);
    }
  };

  return (
    <UnifiedDashboard title="Produtos Reportados">
      <div className="reported-products-container">
        <div className="reported-products-header">
          <div className="reported-products-header-content">
            <i className="fas fa-flag reported-products-header-icon"></i>
            <div>
              <h1 className="reported-products-title">Produtos Denunciados</h1>
              <p className="reported-products-subtitle">{reports.length} produto(s) denunciado(s)</p>
            </div>
          </div>
        </div>

        <div className="reported-products-list-card">
          <div className="reported-products-list-body">
            <table className="reported-products-table">
              <thead>
                <tr>
                  <th>Produto</th>
                  <th>Motivo</th>
                  <th>Detalhes</th>
                  <th>Denunciado por</th>
                  <th>Data</th>
                  <th className="text-center">Ação</th>
                </tr>
              </thead>
              <tbody>
                {pagination.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="reported-products-empty-cell">Nenhum produto denunciado encontrado.</td>
                  </tr>
                ) : (
                  pagination.map((r, i) => (
                    <tr key={i}>
                      <td>
                        <Link to={`/product/${r._id}`} className="reported-products-product-link">
                          {r.product.name}
                        </Link>
                      </td>
                      <td>{r.reason}</td>
                      <td>{r.details}</td>
                      <td>{r.author.name}</td>
                      <td>{moment(r.createdAt).format('DD/MM/YYYY')}</td>
                      <td className="reported-products-table-actions">
                        <Popconfirm
                          placement="top"
                          title="Tem certeza que deseja aprovar?"
                          onConfirm={() => handleApprove(r.product._id)}
                          okText="Sim"
                          cancelText="Não"
                        >
                          <button className="reported-products-btn-approve">
                            Aprovar
                          </button>
                        </Popconfirm>
                        <Popconfirm
                          placement="top"
                          title="Tem certeza que deseja rejeitar?"
                          onConfirm={() => handleReject(r.product._id)}
                          okText="Sim"
                          cancelText="Não"
                        >
                          <button className="reported-products-btn-reject">
                            Rejeitar
                          </button>
                        </Popconfirm>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {reports.length > countPerPage && (
          <div className="reported-products-pagination">
            <Pagination
              current={current}
              total={reports.length}
              pageSize={countPerPage}
              onChange={loadReports}
              showSizeChanger={false}
            />
          </div>
        )}
      </div>
    </UnifiedDashboard>
  );
};

export default ReportedProducts;
